import { SectionHeader } from '@/components/AssetsPage/SectionHeader';
import { BodyText } from '@/components/BodyText';
import { PartFinderForm } from '@/components/PartFinder/PartFinderForm';
import { PartFinderList } from '@/components/PartFinder/PartFinderList';
import { usePageTitle } from '@/hooks/usePageTitle';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const PageContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  width: '100%',
  overflow: 'hidden',
});

const ContentWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  overflow: 'hidden',
});

const FormSection = styled(Box)({
  flexShrink: 0,
});

const TableSection = styled(Box)({
  flex: 1,
  minHeight: 0,
  overflow: 'hidden',
  padding: '0 6px 6px 0',
});

export const PartFinderPage = () => {
  usePageTitle('Part Finder');
  return (
    <PageContainer>
      <ContentWrapper>
        <SectionHeader>
          <BodyText>Part Finder</BodyText>
        </SectionHeader>
        <FormSection>
          <PartFinderForm />
        </FormSection>
        <TableSection>
          <PartFinderList />
        </TableSection>
      </ContentWrapper>
    </PageContainer>
  );
};
